// DO NOT EDIT -- generated from Go package fs/locale

///////////
// Enums //
///////////

export enum ZoneType {
	CountryType = 0,
	RegionType = 1
}

